import {
  mapGetDepot,
  getGasDataFgs,
  getAreas
} from '@/api/mapApi'

import {
  pointChange,
  convertDataFgs
} from '@/cllib/mapToolsNew'

const state = {
  gasData: [],
  depotData: [],
  allDepotData: [],
  areaData: []
}

let gasLoading = false

const getters = {
  mapGasData: state => state.gasData,
  mapDepotData: state => state.depotData,
  mapAllDepotData: state => state.allDepotData,
  mapAreaData: state => state.areaData
}

const actions = {
  async getMapAreaData ({commit, state}) {
    if (state.areaData.length < 1) {
      let data = await getAreas()
      let areaList = []

      data.data.forEach((item) => {
        let shiItem = {
          name: item.name,
          level: 'shi',
          qx: []
        }
        let children = item.children || []
        children.forEach((itemQx) => {
          shiItem.qx.push({
            name: itemQx.name,
            level: 'qx'
          })
        })
        areaList.push(shiItem)
      })
      return commit('setMapAreaData', Object.freeze(areaList))
    } else {
      return Promise.resolve()
    }
  },
  async getMapGasData ({commit, state}) {
    if (state.gasData.length < 1 && !gasLoading) {
      gasLoading = true
      let data = await getGasDataFgs()
      data = data.data.filter(v => v.code && v.code !== '')
      return commit('setMapGasData', Object.freeze(convertDataFgs(data)))
    } else {
      return Promise.resolve()
    }
  },
  async getMapDepotData ({commit, state}) {
    if (state.depotData.length < 1 || state.allDepotData.length < 1) {
      const data = await mapGetDepot()
      let depotZsyGd = []
      let depotZsyTl = []
      let depotZsyDf = []
      let result = []

      data.data.forEach((item) => {
        if (item.type === '油库') {
          let obj = {
            name: item.name,
            type: item.type,
            company: item.company,
            lng: item.lng,
            lat: item.lat,
            o0: item.o0,
            o92: item.o92,
            o95: item.o95,
            o98: item.o98,
            tag: item.tag,
            level: item.level,
            zcType: item.asset_type,
            code: item.code
          }

          obj.point = pointChange([obj.lng, obj.lat])
          if (obj.company === '中石油') {
            if (obj.tag === '管道库') {
              depotZsyGd.push({
                name: obj.name,
                value: obj.point,
                data: obj
              })
            } else if (obj.tag === '地付') {
              depotZsyDf.push({
                name: obj.name,
                value: obj.point,
                data: obj
              })
            } else {
              depotZsyTl.push({
                name: obj.name,
                value: obj.point,
                data: obj
              })
            }
          }

          result.push(obj)
        }
      })

      commit('setMapAllDepotData', Object.freeze(result))
      return commit('setMapDepotData', Object.freeze({
        depot_zsy_gd: depotZsyGd,
        depot_zsy_tl: depotZsyTl,
        depot_zsy_df: depotZsyDf
      }))
    } else {
      return Promise.resolve()
    }
  }
}

const mutations = {
  setMapGasData (state, data) {
    state.gasData = data
    gasLoading = false
  },
  setMapDepotData (state, data) {
    state.depotData = data
  },
  setMapAllDepotData (state, data) {
    state.allDepotData = data
  },
  setMapAreaData (state, data) {
    state.areaData = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/map/common.js